import React, { useEffect, useState } from "react";
import icons from "../../assets/icons/icons";
import ProductBadgeWidget from "../ProductBadgeWidget/ProductBadgeWidget";
import color from "../../assets/colors";
import config from "../../config/config";
import API from "../../services/httpService";
import { Row, Col } from "react-bootstrap";
import { PhotoSwipe } from "react-photoswipe";
import { Form } from "react-bootstrap";
import appService from "../../services/appService";
import { connect } from "react-redux";
import { formatCurrency } from "../../helpers/utils";
import { eventAddToCart } from "../../helpers/events";
import { isIterableArray } from "../../helpers/utils";
import SelectVariants from "./SelectVariants";

const BundlePopup = ({
  onCloseHandler,
  data,
  onToggle,
  setCartItems,
  showLoader,
  hideLoader,
}: any) => {
  const [isOpen, setImageStatus] = useState(false);
  const [state, setState]: any = useState(null);
  const [img, setImg]: any = useState([]);
  const [optional, setOptional]: any = useState({});
  const cardtId = appService.getKey("cartid");
  const [index, setIndex] = useState(1);
  const [VariantOptions, setVarOptions]: any[] = useState([]);
  const [reqArr, setReqArr] = useState([]);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    showLoader();
    API.invokeApi(
      { method: "get", url: `${config.endpoints.productBundle}/${data.id}` },
      (success: boolean, res: any) => {
        if (success) {
          let openPopup = false;
          if(res.Includes?.length > 1){
            openPopup = true
          }
          
          if(openPopup){
            setState(res);
          }else{
            let prod = {};
            let price;
            let discount = data.newPrice !== null ? data.price - data.newPrice : 0;

            price = data.newPrice !== null ? data.newPrice : data.price;

            prod = {
              ...prod,
              id: data.id,
              name: data.title ? data.title : data.displayTitle,
              discount: discount ? +Math.abs(discount).toFixed(2) : 0,
              affiliation: 'Nexersys Store',
              brand: 'Nexersys',
              // item_category: 'pants',
              price: price,
              currency: data.currency ? (data.currency.code ? data.currency.code : 'USD') : 'USD',
              quantity: 1
            };

            const item = {
              currency: 'USD',
              items: [prod],
              value: price
            };
            eventAddToCart(item);
            const request = { productBundleId: data.id, quantity: 1, VariantOptions: [] };
            API.invokeApi(
              { method: 'put', url: `${config.endpoints.getCart}/${cardtId}/cartitems`, data: request },
              (success: boolean, res: any) => {
                if (success && res.id) {
                  const request: any = { method: 'get', url: config.endpoints.getCart };
                  if (appService.getKey('cartid')) {
                    request.headers = { cartid: appService.getKey('cartid') };
                  }
                  API.invokeApi(request, (success: boolean, resp: any) => {
                    if (success && resp.cartId) {
                      appService.setKey('cartid', resp.cartId);
                      setCartItems(resp);
                      hideLoader();
                    } else {
                      hideLoader();
                    }
                    onCloseHandler();
                    onToggle();
                  });
                } else {
                  hideLoader();
                }
              }
            );
          }
          hideLoader();
        } else {
          hideLoader();
        }
      }
    );
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (state && img.length === 0) {
      const img = state.AdditionalImages.map((item: any) => {
        return {
          h: item.height,
          w: item.width,
          src: config.baseUrl + item.url,
        };
      });
      setImg(img);
    }
  }, [state]);

  const GoogleAnalyticsAddToCart = () => {
    let prod = {};
    let price;
    let discount = data.newPrice !== null ? data.price - data.newPrice : 0;
    price = data.newPrice !== null ? data.newPrice : data.price;

    prod = {
      ...prod,
      id: data.id,
      name: data.displayTitle ? data.displayTitle : data.title,
      discount: discount ? +Math.abs(discount).toFixed(2) : 0,
      affiliation: "Nexersys Store",
      brand: "Nexersys",
      // item_category: 'pants',
      price: price,
      currency: data.currency
        ? data.currency.code
          ? data.currency.code
          : "USD"
        : "USD",
      quantity: 1,
    };

    const item = {
      currency: "USD",
      items: [prod],
      value: price,
    };
    eventAddToCart(item);
  };

  const onSubmit = (event: any) => {
    showLoader();
    event.preventDefault();
    GoogleAnalyticsAddToCart();
    // for(let i=0;i<)
    let arrCopy = [...reqArr];
    let objCopy = {};
    state.Includes &&
      state.Includes?.length > 0 &&
      state.Includes?.map((item: any, index: number) => {
        if (
          !item.selectedVariant &&
          item.product &&
          item.product?.ProductVariant &&
          item.product.ProductVariant.length === 0 &&
          data.product !== item.product.id
        ) {
          for (let i = 0; i < item.quantity; i++) {
            objCopy["product"] = item.product.id;
            objCopy["variantKey"] = `0_${item.product.id}`;
            arrCopy.push(objCopy);
            objCopy = {}
          }
        }
      });
    const request = {
      productBundleId: data.id,
      quantity: 1,
      VariantOptions: arrCopy,
    };
    API.invokeApi(
      {
        method: "put",
        url: `${config.endpoints.getCart}/${cardtId}/cartitems`,
        data: request,
      },
      (success: boolean, res: any) => {
        if (success && res.id) {
          setVarOptions([]);
          const request: any = { method: "get", url: config.endpoints.getCart };
          if (cardtId) {
            request.headers = { cartid: cardtId };
          }
          API.invokeApi(request, (success: boolean, resp: any) => {
            if (success && resp.cartId) {
              appService.setKey("cartid", resp.cartId);
              setCartItems(resp);
              hideLoader();
            } else {
              hideLoader();
            }
            onCloseHandler();
            onToggle();
          });
        } else {
          hideLoader();
        }
      }
    );
  };

  const getProductId = (i) => {
    const index = reqArr.findIndex((data) => data.tempId === i);
    return index;
  };

  const changeHandler = (label, value, id, variants, index) => {
    let reqObj = {};
    if (!id) {
      const pid = variants.findIndex((data) => data.value === value);
      const prodId = getProductId(index);
      reqObj["product"] = variants[pid].pid;
      reqObj["variantLabel"] = label;
      reqObj["selectedOption"] = value;
      reqObj["variantKey"] = `0_${variants[pid].pid}_${label}`;
      reqObj["tempId"] = index;
      if (prodId >= 0) {
        const arrCopy = [...reqArr];
        const objCopy = { ...arrCopy[prodId] };
        objCopy["product"] = variants[pid].pid;
        objCopy["variantLabel"] = label;
        objCopy["selectedOption"] = value;
        objCopy["variantKey"] = `0_${variants[pid].pid}_${label}`;
        arrCopy[prodId] = objCopy;
        setReqArr(arrCopy);
      } else {
        const arrCopy = [...reqArr];
        arrCopy.push(reqObj);
        setReqArr(arrCopy);
      }
    } else {
      const prodId = getProductId(index);
      reqObj["product"] = id;
      reqObj["variantLabel"] = label;
      reqObj["selectedOption"] = value;
      reqObj["variantKey"] = `0_${id}_${label}`;
      reqObj["tempId"] = index;
      if (prodId >= 0) {
        const arrCopy = [...reqArr];
        const objCopy = { ...arrCopy[prodId] };
        objCopy["product"] = id;
        objCopy["variantLabel"] = label;
        objCopy["selectedOption"] = value;
        objCopy["variantKey"] = `0_${id}_${label}`;
        arrCopy[prodId] = objCopy;
        setReqArr(arrCopy);
      } else {
        const arrCopy = [...reqArr];
        arrCopy.push(reqObj);
        setReqArr(arrCopy);
      }
    }
  };

  const deleteHandler = (index) => {
    const arrCopy = [...reqArr];
    const pIndex = reqArr.findIndex((data) => data.tempId === index);
    if(pIndex >= 0){
      arrCopy.splice(pIndex, 1);
      setReqArr(arrCopy);
    }
  };

  const generateSpan = (item, quantity, id, index) => {
    let elements = [];
    let arrCopy = [];
    let objCopy = {};
    for (let i = 0; i < quantity; i++) {
      objCopy["product"] = id;
      objCopy["variantKey"] = `0_${id}`;
      elements.push(
        <span className="selected-items" key={`${index}-${i}`}>
          {item}
        </span>
      );
      arrCopy.push(objCopy);
      objCopy = {};
    }
    return elements;
  };

  const getOptions = (arr) => {
    let variants = [];
    let updatedPid;
    arr?.map((data) => {
      if (
        data?.product &&
        data.product?.ProductVariant &&
        data.product?.ProductVariant[0] &&
        data.product?.ProductVariant[0].Variants
      ) {
        updatedPid = data.product.id;
        data.product?.ProductVariant[0].Variants.map((item) => {
          item["pid"] = updatedPid;
          variants.push(item);
        });
      }
    });

    return variants;
  };

  const getElementWithQuantity = (item, quantity, index) => {
    let elements = [];
    const variants = getOptions(item.OptionalProducts);
    // setVariants(variants)
    for (let i = 0; i < quantity; i++) {
      elements.push(
        <SelectVariants
          type="product.choice-of-product"
          data={item.OptionalProducts[0]}
          key={`${index}-${i}`}
          variants={variants}
          changeHandler={changeHandler}
          deleteHandler={deleteHandler}
          index={`${index}-${i}`}
        />
      );
    }
    return elements;
  };

  const getElementWithQuantitySingle = (item, quantity, index) => {
    let elements = [];
    let uid = 0;
    for (let i = 0; i < quantity; i++) {
      item.OptionalProducts?.map((data, key) =>
        elements.push(
          <SelectVariants
            type="product.choice-of-product"
            data={data}
            key={`${index}-${i}`}
            variants={null}
            changeHandler={changeHandler}
            deleteHandler={deleteHandler}
            index={`${index}-${i}`}
          />
        )
      );
      uid++;
    }
    return elements;
  };

  return (
    state && (
      <div className="Bundle-overlay">
        <div className="Bundle-container">
          <div className="product-details-container">
            <span className="bundle-close-icon" onClick={onCloseHandler}>
              {icons.close(color.$black, "")}
            </span>
            <Row lg={2} sm={1} xs={1}>
              <Col>
                <div className="app-image-section">
                  <div
                    className="app-image-main"
                    style={{
                      backgroundImage: `url(${
                        state.image ? config.baseUrl + state.image[0].url : ""
                      })`,
                    }}
                  />
                  <p>{state.description}</p>
                  <div className="app-sub-img-container">
                    {state.image && state.image.length > 0 &&
                      state.image.map((item: any, i: number) => {
                        if (i <= 4) {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setIndex(i);
                                setImageStatus(true);
                              }}
                              className="app-sub-image"
                              style={{
                                backgroundImage: `url(${
                                  item.url ? item.url : ""
                                })`,
                              }}
                            />
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>
                </div>
              </Col>
              <Col>
                <div className="app-desc-section">
                  <h1>{state.product.title}</h1>
                  <h3>{state.title}</h3>

                  {state.price && state.newPrice && (
                    <h2>
                      <span className="old-price">
                        {state.currency.symbol}
                        {formatCurrency(state.price)}
                      </span>
                      <span className="new-price">
                        {state.currency.symbol}
                        {formatCurrency(state.newPrice)}
                      </span>
                    </h2>
                  )}

                  {!state.newPrice && state.price && (
                    <h2>
                      <span className="new-price">
                        {state.currency.symbol}
                        {formatCurrency(state.price)}
                      </span>
                    </h2>
                  )}

                  {state.newPrice && (
                    <h6>
                      You Save {state.currency.symbol}
                      {formatCurrency(
                        (state.price - state.newPrice).toFixed(2)
                      )}
                      !
                    </h6>
                  )}
                  {state.Includes &&
                    state.Includes?.length > 0 &&
                    state.Includes?.map((item: any, index: number) => {
                      if (
                        !item.selectedVariant &&
                        item.product &&
                        item.product?.ProductVariant &&
                        item.product.ProductVariant.length === 0 &&
                        data.product !== item.product.id
                      ) {
                        return generateSpan(
                          item.product.title,
                          item.quantity,
                          item.product.id,
                          index
                        );
                      }
                    })}
                  <Form onSubmit={onSubmit}>
                    <div className="form-container">
                      {state.Includes &&
                        state.Includes.map((item: any, i: number) => {
                          switch (item.__component) {
                            // case "product.choice-of-product":
                            //   if(!item.selectedVariant){

                            //   }
                            case "product.choice-of-product":
                              if (
                                item &&
                                item?.OptionalProducts &&
                                isIterableArray(item?.OptionalProducts)
                              ) {
                                return item.OptionalProducts?.length > 1
                                  ? getElementWithQuantity(
                                      item,
                                      item.quantity,
                                      i
                                    )
                                  : getElementWithQuantitySingle(
                                      item,
                                      item.quantity,
                                      i
                                    );
                              }
                            default:
                              return null;
                          }
                        })}
                      <input
                        type="submit"
                        className="app-cart-btn"
                        value="add to cart"
                      />
                    </div>
                  </Form>

                  <div className="invalid-feedback">Choose an Option</div>

                  <span className="app-note-section">{state.shippingNote}</span>
                </div>
              </Col>
            </Row>
            {/* <ProductBadgeWidget popup={false} data={state.AdditionalInfo} /> */}
          </div>
        </div>
        {state.image && state.image?.length > 0 && (
          <PhotoSwipe
            items={state.image}
            isOpen={isOpen}
            onClose={() => {
              setImageStatus(false);
            }}
            options={{ index: index }}
          />
        )}
      </div>
    )
  );
};

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart,
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: "TOGGLE_CART" }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: "ON_CART_LOAD", payload: cartItems });
    },
    showLoader: () => dispatch({ type: "LOADER_SHOW" }),
    hideLoader: () => dispatch({ type: "LOADER_HIDE" }),
  };
};

export default connect(mapState, mapDispatch)(BundlePopup);
